import { useCatalogSettingContext } from "context/CatalogSettingContext";
import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import clientReportsAPIs from "../Report/api/clientReportsAPIs";

const withReportData = (WrappedComponent, catalogProductsDetails, catalogProductsReports, routTille) => {
  return (props) => {
    const [btnTitles, setBtnTitles] = useState({});
    const [reportData, setReportData] = useState([]);
    const { setUserReport, setUserCurrentPath, setSortModal } = useCatalogSettingContext();

    const handleShowDetails = (_id) => {
      setBtnTitles((prev) => ({ ...prev, [_id]: "Hide Details" }));
    };

    const handleHideDetails = (_id) => {
      setBtnTitles((prev) => ({ ...prev, [_id]: "Show Details" }));
    };

    const location = useLocation();
    let companyName = new URLSearchParams(window.location.search).get("companyName");

    useEffect(() => {
      setUserReport(false);

      setUserCurrentPath({
        name: routTille === "Client Report" && !companyName ? `${routTille} ${location?.state?.subName || ""}` : companyName,
        path: location?.pathname,
      });

      return () => {
        setUserReport(true);
        setUserCurrentPath({});
      };
    }, [location, setUserCurrentPath, setUserReport]);

    useEffect(() => {
      return () => setSortModal(false);
    }, [setSortModal]);

    return (
      <WrappedComponent
        {...props}
        btnTitles={btnTitles}
        setBtnTitles={setBtnTitles}
        reportData={reportData}
        setReportData={setReportData}
        handleShowDetails={handleShowDetails}
        handleHideDetails={handleHideDetails}
      />
    );
  };
};

export default withReportData;
